import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a reports icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ReportsIcon width={12} />
 */
const ReportsIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20.206 26.032h-.867v6.726h.895c.74 0 1.308-.263
            1.705-.79s.595-1.31.595-2.35v-.462c0-1.033-.198-1.812-.595-2.337-.396-.525-.975-.788-1.734-.788zM10.51
            26.032H8.79v3.087h1.69c.5 0
            .88-.125 1.143-.375.26-.25.393-.603.393-1.058 0-.5-.134-.9-.404-1.197-.27-.3-.638-.45-1.103-.458z`}
        />
        <path
            d={`M36.343 19.69H4.087c-1.183 0-2.15.97-2.15 2.15v15.053c0 1.183.968
            2.15 2.15 2.15h32.255c1.183 0 2.15-.968
            2.15-2.15V21.84c0-1.182-.967-2.15-2.15-2.15zM13.51
            30.176c-.747.624-1.772.936-3.075.936H8.79v3.632H6.21v-10.7h4.27c.817
            0 1.54.15 2.172.45.63.303 1.117.732 1.462 1.288.346.557.52 1.187.52
            1.892-.002 1.044-.376 1.878-1.124 2.503zm11.657-.556c0 .98-.207
            1.858-.622 2.634-.414.777-.996 1.384-1.75
            1.823-.75.44-1.59.662-2.516.666h-3.522v-10.7h3.447c.946 0 1.795.213
            2.55.642.755.428 1.344 1.035 1.768 1.816.423.782.637 1.658.643
            2.628v.49zm9.235-3.588h-4.58v2.463h4.16v1.985h-4.16v4.263h-2.58v-10.7h7.16v1.99z`}
        />
        <path
            d={`M38.66 2H12.69c-1.457 0-2.64 1.183-2.64
            2.64v13.39h3.165V5.696c0-.323.263-.586.586-.586h19.873v5.984c0 1.456
            1.184 2.64 2.64 2.64h6.03v28.52c0 .322-.264.585-.587.585H13.8c-.322
            0-.585-.264-.585-.587v-1.548H10.05v2.64c0 1.457 1.183 2.64 2.64 2.64h30.104c1.456
            0 2.64-1.183 2.64-2.64V8.73l-6.775-6.73z`}
        />
    </SvgIcon>
)

ReportsIcon.defaultProps = defaultProps

export { ReportsIcon }
